import { render, staticRenderFns } from "./DocumentVirtualOfficeHire.vue?vue&type=template&id=c829b708&scoped=true&"
import script from "./DocumentVirtualOfficeHire.vue?vue&type=script&lang=js&"
export * from "./DocumentVirtualOfficeHire.vue?vue&type=script&lang=js&"
import style0 from "./DocumentVirtualOfficeHire.vue?vue&type=style&index=0&id=c829b708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c829b708",
  null
  
)

export default component.exports